import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { useProductDetailSlots } from "../../../../../../slots/slots/context.js";
/* empty css                        */
const ProductDetailTitle = ({ title, subtitle, sku, href }) => {
  const { Slots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement("div", { className: "product-detail-title" }, /* @__PURE__ */ React.createElement("div", { className: "product-detail-title__subtitle-row" }, !!href ? /* @__PURE__ */ React.createElement("a", { href, className: "product-detail-title__link", "data-t": "product-detail-title-link" }, subtitle) : /* @__PURE__ */ React.createElement("span", { className: "product-detail-title__subtitle", "data-t": "product-detail-title-subtitle" }, subtitle), /* @__PURE__ */ React.createElement(Slots.WishlistButton, { sku, productLocation: "pdp" })), /* @__PURE__ */ React.createElement(
    Heading,
    {
      variant: "small",
      component: "h1",
      className: "product-detail-title__title",
      "data-t": "product-detail-title"
    },
    title
  ));
};
export {
  ProductDetailTitle
};
//# sourceMappingURL=ProductDetailTitle.js.map
